/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  const { isFocused, selectProps } = props;
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={isFocused}>
        {selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, child => {
          return child && child.type !== Placeholder ? child : null;
      })}
    </ValueContainer>
  )
};

CustomValueContainer.defaultProps = {
  isFocused: false,
}

CustomValueContainer.propTypes = {
  isFocused: PropTypes.bool,
  selectProps: PropTypes.shape({
    placeholder: PropTypes.string
  }).isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
}

export default CustomValueContainer;
